import React from 'react';

import CustomTh from '../shared/table/CustomTh';
import Table from 'react-bootstrap/Table';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import OpenBalancesItem from './OpenBalancesItem';
import useFilter from '../../utilities/useFilter';
import PagedListControl from '../shared/lists/PagedListControl';

const OpenBalances = () => {
    const { items, submitFilter, pageInfo } = useFilter('/api/dashboard/openBalances', {}, true);

    const tableHead = (
        <thead>
            <tr>
                <CustomTh width="28px" style={{ padding: '0' }} />
                <CustomTh content="Customer" style={{ boxShadow: 'none' }} />
                <CustomTh hide="sm" width="85px" content="Date" />
                <CustomTh hide="sm" width="50px" content="Terms" />
                <CustomTh width="85px" content="Due" />
                <CustomTh width="75px" content="Balance" />
                <CustomTh width="70px" content="Payments" />
            </tr>
        </thead>
    );

    const listItems = items && items.map((item) =>
        <OpenBalancesItem
            fetchData={submitFilter}
            item={item}
            key={item.recordId + item.recordType}
        />);

    return (
        <div className="dashboard-container">
            <Col>
                <Row>
                    <Col>
                        <div className="dashboard-follow-ups-title">Open Balances</div>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <div className="fixed-table-head dashboard-follow-ups">
                            <Table striped size="sm">
                                {tableHead}
                                <tbody>
                                    {listItems}
                                </tbody>
                            </Table>
                            {(pageInfo.isFirstPage && pageInfo.isLastPage) ||
                                <PagedListControl {...pageInfo} />
                            }
                        </div>
                    </Col>
                </Row>
            </Col>
        </div>
    );
}

export default OpenBalances;